import axiosInstance from "./AxiosInstance";

export function updateCompanyProfile(profileData) {
  return axiosInstance.put("recruiter/user/update/profile", profileData);
}

export function getProfile() {
   return axiosInstance.get("recruiter/profile/details");
 }
